import type { MyFilesSearchSchema } from "./page-search-schema";

export function getFileConfig({
  brandId,
  folder,
  projectId,
  requestId,
  requestType,
}: MyFilesSearchSchema): null | string {
  if (folder && requestId && projectId) {
    const params = new URLSearchParams({
      folder,
      projectId: projectId.toString(),
    });

    return `/request/${requestId}?${params.toString()}`;
  }

  if (requestId && projectId) {
    const params = new URLSearchParams({
      projectId: projectId.toString(),
    });

    return `/request/${requestId}?${params.toString()}`;
  }

  if (brandId && requestType && projectId) {
    const params = new URLSearchParams({
      projectId: projectId.toString(),
      requestType: requestType,
    });

    return `/brand/${brandId}?${params.toString()}`;
  }

  if (brandId && projectId) {
    const params = new URLSearchParams({
      projectId: projectId.toString(),
    });

    return `/brand/${brandId}?${params.toString()}`;
  }

  if (projectId) {
    const params = new URLSearchParams({ projectId: projectId.toString() });

    return `/account/${projectId}?${params.toString()}`;
  }

  return null;
}
